import React from 'react';

import { BaseIconProps } from '.';

export const Cross = ({ fill }: BaseIconProps) => (
  <path
    d="M1080 140.94L939.06 0L540 399.15L140.94 0L0 140.94L399.15 540L0 939.06L140.94 1080L540 680.85L939.06 1080L1080 939.06L680.85 540L1080 140.94Z"
    fill={fill}
  />
);
